import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    OrderLine as OrderLineModel,
    CreateOrderLineDocument,
    UpdateOrderLineDocument, RemoveOrderLineMutationVariables, RemoveOrderLineDocument
} from "@/endpoints/rutsolve/gql/generated/graphql"
import {
    CreateOrderLineMutationVariables,
    UpdateOrderLineMutationVariables
} from "@/endpoints/rutsolve/gql/generated/types"

export class OrderLine extends Client {
    constructor() {
        super()
    }

    public async create(input: OrderLineModel) {
        try {
            const variables: CreateOrderLineMutationVariables = {
                input: {
                    amount: this.decimal(input.amount),
                    deliverableID: input.deliverableID,
                    description: input.description,
                    discountType: input.discountType,
                    discountValue: this.decimal(input.discountValue),
                    orderID: input.orderID,
                    priority: input.priority,
                    unit: input.unit,
                    unitPrice: this.decimal(input.unitPrice.net),
                    vatRate: this.decimal(input.vatRate)
                }
            }
            if (input.deliverable && input.deliverable.id) {
                variables.input.deliverableID = input.deliverable.id
            }
            await this.client.request(CreateOrderLineDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async update(input: OrderLineModel) {
        try {
            const variables: UpdateOrderLineMutationVariables = {
                input: {
                    amount: this.decimal(input.amount),
                    deliverableID: input.deliverableID,
                    description: input.description,
                    discountType: input.discountType,
                    discountValue: this.decimal(input.discountValue),
                    id: input.id,
                    priority: input.priority,
                    unit: input.unit,
                    unitPrice: this.decimal(input.unitPrice.net),
                    vatRate: this.decimal(input.vatRate)
                }
            }
            if (input.deliverable && input.deliverable.id) {
                variables.input.deliverableID = input.deliverable.id
            }
            await this.client.request(UpdateOrderLineDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async remove(orderLineID: string) {
        try {
            const variables: RemoveOrderLineMutationVariables = {
                orderLineID: orderLineID
            }
            await this.client.request(RemoveOrderLineDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }
}
